import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ReactComponent as Success } from '@/assets/icons/success.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 36px;
  padding: 0 10px;
  gap: 10px;
  background: #fff;
`;

export const Block = styled.div<{ gap?: string; justifyContent?: string; width?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || 'normal'};
  width: ${({ width }) => width || 'auto'};
  gap: ${({ gap }) => gap || '4px'};
`;

export const Button = styled.button<{ isActive?: boolean; fontSize?: string; textTransform?: string }>`
  flex-shrink: 0;
  max-width: 110px;
  height: 20px;
  padding: 0 5px;
  color: #7e7c7c;
  font-size: ${({ fontSize }) => fontSize || '14px'};
  font-weight: bold;
  font-family: sans-serif;
  text-overflow: ellipsis;
  text-transform: ${({ textTransform }) => textTransform || 'none'};
  overflow: hidden;
  letter-spacing: 0.04em;
  white-space: nowrap;
  border: 1px solid #ccc;
  border-radius: 4px;

  ${({ theme }) => theme.maintenance.groupButton.styles};

  ${({ isActive, theme }) =>
    isActive &&
    css`
      color: #000;
      ${theme.maintenance.groupButton.active}
    `}
`;

export const Label = styled.label`
  margin-top: 2px;
  font-size: 8px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const Copied = styled.label`
  margin-top: 2px;
  color: green;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
`;

export const SuccessIcon = styled(Success)`
  max-width: 16px;
  height: auto;
  fill: green;
`;
